export default {
  props: {
    type: {
      type: String,
      default: 'primary'
    },
    disabled: Boolean
  }
}



// WEBPACK FOOTER //
// ./src/mixins/common.js